import { useState } from 'react';
import { motion } from 'motion/react';
import { Database, Download, CheckCircle, Clock } from 'lucide-react';

export const DatabaseBackup = () => {
  const [isBackingUp, setIsBackingUp] = useState(false);
  const [backups, setBackups] = useState([
    { id: 1, date: '۱۴۰۲/۰۷/۱۵ ۱۰:۳۰', size: '25 MB', status: 'موفق' },
    { id: 2, date: '۱۴۰۲/۰۷/۱۴ ۱۲:۱۵', size: '24.5 MB', status: 'موفق' },
  ]);

  const handleBackup = () => {
    setIsBackingUp(true);
    // Simulate backup process
    setTimeout(() => {
      setIsBackingUp(false);
      const newBackup = {
        id: Date.now(),
        date: new Date().toLocaleDateString('fa-IR') + ' ' + new Date().toLocaleTimeString('fa-IR', {hour: '2-digit', minute:'2-digit'}),
        size: '25.2 MB',
        status: 'موفق'
      };
      setBackups([newBackup, ...backups]);
    }, 3000);
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 overflow-hidden">
      <div className="p-6 border-b border-slate-100 dark:border-slate-700/50 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h3 className="font-bold text-xl text-slate-800 dark:text-white">کپی و بک‌آپ دیتابیس</h3>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">نسخه پشتیبان از دیتابیس سیستم بگیرید و آرشیوها را مدیریت کنید.</p>
        </div>
        <button 
          onClick={handleBackup}
          disabled={isBackingUp}
          className="bg-purple-600 hover:bg-purple-700 disabled:bg-purple-400 text-white px-5 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 shrink-0 transition-colors shadow-lg shadow-purple-500/30"
        >
          {isBackingUp ? (
            <>
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              <span>در حال ایجاد نسخه پشتیبان...</span>
            </>
          ) : (
            <>
              <Database size={18} />
              <span>تهیه نسخه پشتیبان جدید</span>
            </>
          )}
        </button>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-right">
          <thead className="bg-slate-50 dark:bg-slate-900/50 text-slate-500 dark:text-slate-400 text-sm">
            <tr>
              <th className="px-6 py-4 font-medium">تاریخ و ساعت</th>
              <th className="px-6 py-4 font-medium">حجم فایل</th>
              <th className="px-6 py-4 font-medium">وضعیت</th>
              <th className="px-6 py-4 font-medium text-left">عملیات</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
            {backups.map((backup) => (
              <tr key={backup.id} className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors">
                <td className="px-6 py-4 text-slate-800 dark:text-slate-200 font-medium">
                  <div className="flex items-center gap-2">
                    <Clock size={16} className="text-slate-400" />
                    {backup.date}
                  </div>
                </td>
                <td className="px-6 py-4 text-slate-600 dark:text-slate-400" dir="ltr">{backup.size}</td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20">
                    <CheckCircle size={14} />
                    {backup.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-left">
                  <button className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition-colors flex items-center justify-end gap-1.5 ms-auto">
                    <Download size={18} />
                    <span className="text-sm">دانلود</span>
                  </button>
                </td>
              </tr>
            ))}
            {backups.length === 0 && (
              <tr>
                <td colSpan={4} className="px-6 py-12 text-center text-slate-500 dark:text-slate-400">
                  هیچ نسخه پشتیبانی یافت نشد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
